import { useEffect } from "react";

/**
 * Cichy tracker odwiedzin — bez UI, bez PII.
 *   • Sesje: sessionStorage → 1 wizyta na sesję przeglądarki.
 *   • Unikalni: localStorage → 1 unikalna wizyta na przeglądarkę na dzień UTC.
 * Fire-and-forget POST /api/track-visit?unique=0|1 przez sendBeacon.
 * Ignorowane na panelu admina, żeby nie zawyżać statystyk.
 */
function todayUtcISO() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC)
}

export default function VisitTracker() {
  useEffect(() => {
    try {
      if (typeof window === "undefined") return;
      if (window.location.pathname.includes("/mgmt-lyp-")) return;

      const SESSION_KEY = "lyp-visit-tracked";
      const alreadyThisSession = window.sessionStorage.getItem(SESSION_KEY) === "1";
      if (alreadyThisSession) return; // nie liczymy wielokrotnie w tej samej sesji
      window.sessionStorage.setItem(SESSION_KEY, "1");

      // Unikalne w skali dnia (localStorage, żeby przeżyć zamknięcie przeglądarki)
      const today = todayUtcISO();
      const UNIQ_KEY = "lyp-uniq-day";
      const lastUniqDay = window.localStorage.getItem(UNIQ_KEY);
      const isUniqueToday = lastUniqDay !== today;
      if (isUniqueToday) window.localStorage.setItem(UNIQ_KEY, today);

      const url = `${process.env.REACT_APP_BACKEND_URL}/api/track-visit?unique=${isUniqueToday ? 1 : 0}`;
      const body = new Blob(["{}"], { type: "application/json" });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, body);
      } else {
        fetch(url, { method: "POST", keepalive: true }).catch(() => {});
      }
    } catch {
      /* silent */
    }
  }, []);
  return null;
}
